module.exports = __webpack_public_path__ + "static/img/manual-23.d9e5e66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-23.png
// module id = sxQJ
// module chunks = 4